import React from "react";
import { Modal, Row, Col, Form, Container, InputGroup } from "react-bootstrap";
import parse from 'html-react-parser';

import CancelButton from "presentation/components/buttons/cancel";
import AddButton from "presentation/components/buttons/add";

import { handleChange } from "presentation/utils/functions/generic";

import EvaluationFormula from "presentation/pages/evaluation-schemes/elements/evaluation-formula/evaluation-formula";

import { stageCriteriaFormulaTypes, STAGE_CRITERIA_FORMULA_TYPE_DEFAULT, STAGE_FORMULA_TYPE_CUSTOM, TERM_INFO_ITEM_TYPE_EVALUATION_STAGE } from "presentation/model/constants";
import { generateStageCriteriaVirtualId } from "presentation/pages/evaluation-schemes/functions/stage-criterias";

class ManageStageCriteriaModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            form: {
                stagesFormulaType: STAGE_CRITERIA_FORMULA_TYPE_DEFAULT
            }
        };
    }


    componentDidMount() {
        let { stageCriteria = {} } = this.props;
        this.setState({ form: stageCriteria });
        this.loadTerms();
    }

    componentDidUpdate(prevProps, prevState) {
        const { stages, stageCriteria } = this.props;
        const { stages: previousStagesParam, stageCriteria: previousStageCriteriaParam } = prevProps;

        if (stageCriteria != previousStageCriteriaParam) {
            this.setState({ form: stageCriteria });
        }

        if (stages != previousStagesParam) {
            this.loadTerms();
        }
    }

    loadTerms = () => {
        let { stages } = this.props;
        let terms = stages.map((p, pi) => {
            return { id: p.id, displayName: p.name, machineName: `stage:${p.id}`, isUnique: true, termInfoItemType: TERM_INFO_ITEM_TYPE_EVALUATION_STAGE };
        });
        this.setState({ terms: terms });
    }

    updateStagesFormulaExpression = (entityKey, elements) => {
        const { form } = this.state;
        this.setState({ form: { ...form, stagesFormula: elements } });
    }

    updateReverseStagesFormulaExpression = (entityKey, elements) => {
        const { form } = this.state;
        this.setState({ form: { ...form, reverseStagesFormula: elements } });
    }


    onSubmit = () => {

        let { onClose, afterSubmit, component, stageCriteriaKey } = this.props;
        let { form } = this.state;
        let { stageCriterias: existingStageCriterias } = component.state;
        let hasError = !form.stageId;

        if (hasError) {
            this.setState({ loading: false, error: true, message: "Campos obrigatórios não foram preenchidos. Por favor, verifique a etapa. " });
        } else {

            let stageCriteria = form;
            let existing = existingStageCriterias.filter(x => x.key == stageCriteriaKey)[0];

            if (!existing) {
                let tempId = generateStageCriteriaVirtualId();
                stageCriteria.id = tempId;
                stageCriteria.tempId = tempId;
                stageCriteria.isVirtualId = true;
                stageCriteria.key = stageCriteriaKey;
            }

            let finalStageCriterias = [...existingStageCriterias.filter(x => x.key !== stageCriteriaKey), stageCriteria];

            component.setState({
                stageCriterias: finalStageCriterias,
                totalStageCriteriaItems: finalStageCriterias.length
            }, () => {
                this.setState({
                    form: {}
                }, () => {
                    afterSubmit();
                    onClose();
                });
            });


        }
    };


    render() {
        let { show, onClose, stages, stageCriteriaKey, mode = "add" } = this.props;
        let { loading, form, terms } = this.state;
        let { stageId, stagesFormula, reverseStagesFormula } = form || {};

        const { onSubmit, updateStagesFormulaExpression, updateReverseStagesFormulaExpression, } = this;

        let component = this;
        let entityKey = stageCriteriaKey;

        let allowDisciplinesFailure = form.allowDisciplinesFailure || false;
        let stageIdValue = stageId ? ("" + stageId) : "";
        let existingElements = stagesFormula || [];
        let reverseExistingElements = reverseStagesFormula || [];

        return (
            <Modal size="fullscreen" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{mode == "add" ? "Adicionar" : "Editar"} critério de aprovação/reprovação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Form.Label htmlFor="stageId">Etapa</Form.Label>
                                <Form.Select
                                    aria-label="Etapa"
                                    value={stageIdValue}
                                    id={`stageId`}
                                    name={`stageId`}
                                    data-field-name="stageId"
                                    onChange={(e) => handleChange(e, component)}
                                    required
                                >
                                    <option key="-1" value="-1">Selecione</option>
                                    {stages.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                </Form.Select>
                            </Col>
                        </Row>
                        {form.stageId != null && form.stageId != "-1" && (
                            <Row>
                                <Col lg={12}>
                                    <table className="table mt-2">
                                        <thead>
                                            <tr>
                                                <th width="100%">Critério</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <InputGroup>
                                                        <InputGroup.Text>{"Se a média for >= a"}</InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            id="neededScore"
                                                            name="neededScore"
                                                            defaultValue={form.neededScore}
                                                            onChange={(e) => handleChange(e, component)}
                                                        />
                                                        <Form.Select
                                                            aria-label="Etapa quando aprovado"
                                                            defaultValue={form.relatedStageOnSuccessId}
                                                            id={`relatedStageOnSuccessId`}
                                                            name={`relatedStageOnSuccessId`}
                                                            data-field-name="relatedStageOnSuccessId"
                                                            onChange={(e) => handleChange(e, component)}
                                                        >
                                                            <option value="0">o aluno está aprovado nesse critério</option>
                                                            {stages.filter(x => x.id != form.stageId).map((e, i) => { return <option key={e.id} value={e.id}>{`o aluno será avaliado na ${e.name}`}</option> })}
                                                        </Form.Select>
                                                    </InputGroup>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <InputGroup>
                                                        <InputGroup.Text>{"Se a média for < que"}</InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            value={form.neededScore}
                                                            disabled
                                                        />
                                                        <Form.Select
                                                            aria-label="Etapa quando reprovado"
                                                            defaultValue={form.relatedStageOnFailureId}
                                                            id={`relatedStageOnFailureId`}
                                                            name={`relatedStageOnFailureId`}
                                                            data-field-name="relatedStageOnFailureId"
                                                            onChange={(e) => handleChange(e, component)}
                                                        >
                                                            <option value="0">o aluno está reprovado nesse critério</option>
                                                            {stages.filter(x => x.id != form.stageId).map((e, i) => { return <option key={e.id} value={e.id}>{`o aluno será avaliado na ${e.name}`}</option> })}
                                                        </Form.Select>
                                                    </InputGroup>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <InputGroup>
                                                        <InputGroup.Checkbox
                                                            checked={allowDisciplinesFailure}
                                                            id={`allowDisciplinesFailure`}
                                                            name={`allowDisciplinesFailure`}
                                                            data-field-name="allowDisciplinesFailure"
                                                            onChange={(event) => handleChange(event, component)}
                                                        />
                                                        <InputGroup.Text>{"Se a média < que"}</InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            value={form.neededScore}
                                                            disabled
                                                        />
                                                        <InputGroup.Text>{"em mais de"}</InputGroup.Text>
                                                        <Form.Control
                                                            type="text"
                                                            id="maxDisciplinesFailures"
                                                            name="maxDisciplinesFailures"
                                                            defaultValue={form.maxDisciplinesFailures}
                                                            onChange={(e) => handleChange(e, component)}
                                                            disabled={!allowDisciplinesFailure}
                                                        />
                                                        <InputGroup.Text>disciplina(s), o aluno está reprovado nesse critério</InputGroup.Text>
                                                    </InputGroup>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Col>
                                <Col lg={12}>
                                    <div className="mt-2">
                                        <Form.Label htmlFor="stagesFormulaType">Para cálcular a média nesse critério, levar em consideração</Form.Label>
                                        <Form.Select
                                            aria-label="Tipo de fórmula do critério"
                                            defaultValue={form.stagesFormulaType}
                                            id={`stagesFormulaType`}
                                            name={`stagesFormulaType`}
                                            data-field-name="stagesFormulaType"
                                            onChange={(e) => handleChange(e, component)}
                                            required
                                        >
                                            {stageCriteriaFormulaTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                        </Form.Select>
                                    </div>
                                </Col>
                            </Row>
                        )}
                        {form.stagesFormulaType == STAGE_FORMULA_TYPE_CUSTOM && (
                            <div className="mt-2">
                                <div className="mt-2">
                                    <strong>Fórmula customizada:</strong>
                                    <EvaluationFormula component={component} entityKey={entityKey} sortableKey={`ev-stage-criteria-main-${entityKey}`} updateExpression={updateStagesFormulaExpression} terms={terms} existingElements={existingElements} />
                                </div>
                                <div className="mt-2">
                                    <strong>Para calcular quanto falta para alcançar os pontos, utilizar a fórmuila abaixo:</strong>
                                    <EvaluationFormula component={component} entityKey={entityKey} sortableKey={`ev-stage-criteria-secondary-${entityKey}`} updateExpression={updateReverseStagesFormulaExpression} terms={terms} existingElements={reverseExistingElements} />
                                </div>
                            </div>
                        )}
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <AddButton
                        title={"Salvar"}
                        containerProps={{
                            onClick: () => onSubmit(),
                            variant: 'success',
                            disabled: loading
                        }}
                    />
                </Modal.Footer>
            </Modal >
        );
    };
}

export default ManageStageCriteriaModal;